import { Line, Polygon } from '@visx/shape'

import {
  INHERITANCE_ARROW_HEIGHT,
  INHERITANCE_ARROW_RADIUS,
  NODE_COLLAPSED_SPACING_VERTICAL,
} from './constants'

type Props = {
  x: number
  y: number
}

export const InheritancePathVertical = ({ x, y }: Props) => (
  <>
    <Polygon
      sides={3}
      className="fill-transparent stroke-inheritance stroke-1"
      size={INHERITANCE_ARROW_RADIUS}
      rotate={90}
      center={{
        x,
        y: y - NODE_COLLAPSED_SPACING_VERTICAL + INHERITANCE_ARROW_RADIUS,
      }}
    />
    <Line
      className="stroke-inheritance stroke-1"
      from={{
        x,
        y: y - NODE_COLLAPSED_SPACING_VERTICAL + INHERITANCE_ARROW_HEIGHT,
      }}
      to={{ x, y }}
    />
  </>
)
